import { ColumnDef } from '@tanstack/react-table';

import DataTable from 'components/DataTableComponent/DataTable';
import EmptyState from 'components/EmptyState/EmptyState';

import { OfferDesignRow } from '../../types';

interface TableContentProps {
  isLoading: boolean;
  offers: OfferDesignRow[];
  filteredOffers: OfferDesignRow[];
  columns: ColumnDef<OfferDesignRow>[];
  canManage: boolean;
  onCreate: () => void;
}

export const TableContent = ({
  isLoading,
  offers,
  filteredOffers,
  columns,
  canManage,
  onCreate
}: TableContentProps) => {
  if (isLoading) {
    return (
      <div className="flex justify-center items-center w-full h-[200px]">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-zinc-200 border-t-indigo-600" />
      </div>
    );
  }

  if (offers.length === 0) {
    return (
      <EmptyState
        title="Add your first Offer Design"
        description="Create a design that defines how your offers will look"
        buttonText="Create Offer Design"
        disableButton={!canManage}
        className="mx-auto mt-36"
        onClick={onCreate}
      />
    );
  }

  return (
    <div className="border border-base-sidebarBorder rounded-lg mx-7 mb-9">
      <DataTable
        data={filteredOffers}
        columns={columns}
        rowIdIdentifier="_id"
        bodyDataTestId="dashOffersDesignList"
        rowsPerPage={offers.length}
        showPagination={false}
      />
    </div>
  );
};
